import React, { useState } from "react";

import DispatchSearch from "../dispatch/dispatchSearch";





const  dispatchLayout =() => {
return (
  
    <DispatchSearch></DispatchSearch>
  

  );
}

export default dispatchLayout;
